export default __webpack_public_path__ + "a03c508b716a51c3cab4d1a62b394ede.svg";